import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { ClipboardCheck, FileText, Settings, ArrowLeft } from "lucide-react";

const links = [
  { to: "/", label: "Checklist", icon: ClipboardCheck, id: "nav-checklist" },
  { to: "/history", label: "Reports", icon: FileText, id: "nav-history" },
  { to: "/settings", label: "Tasks", icon: Settings, id: "nav-settings" },
];

export const Header = () => {
  const nav = useNavigate();
  const { pathname } = useLocation();
  return (
  <header className="bg-[#2A3C36] border-b border-[#1f2d28] sticky top-0 z-40">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 h-20 flex items-center justify-between gap-4">
      <div className="flex items-center gap-2">
        {pathname !== "/" && (
          <button
            type="button"
            data-testid="back-button"
            onClick={() => (window.history.state?.idx > 0 ? nav(-1) : nav("/"))}
            className="p-2 rounded-full text-white/60 hover:bg-white/10 hover:text-white transition-colors duration-200"
            title="Back"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
        )}
        <NavLink to="/" className="flex items-center gap-3" data-testid="header-logo">
          <img src="/logo.png" alt="Sikara Lombok Hotel" className="h-12 sm:h-14 w-auto" data-testid="header-logo-image" />
          <span className="font-accent italic text-[#C87D55] text-base">Front Office</span>
        </NavLink>
      </div>
      <nav className="flex items-center gap-1">
        {links.map(({ to, label, icon: Icon, id }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            data-testid={id}
            className={({ isActive }) =>
              `flex items-center gap-2 px-3 py-2 rounded-full text-sm font-medium transition-colors duration-200 ${
                isActive ? "bg-[#C87D55] text-white" : "text-white/60 hover:bg-white/10 hover:text-white"
              }`
            }
          >
            <Icon className="w-4 h-4" />
            <span className="hidden sm:inline">{label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  </header>
  );
};
